<template lang="">
  <div class="all">
    <div v-if="language == 'en'" class="extendedRichtext">
      <h1 class="text">Imprint</h1>
      <div>
        <div class="text"><h3>Service Provider:</h3></div>
        <div class="text">
          <p>
            Henkel (China) Investment Co., Ltd., hereinafter referred to as
            "Henkel Corporation" or "Our Company")
          </p>
        </div>
        <div class="text"><h3>Registered Office:</h3></div>
        <div class="text">
          <p>
            5th, 6th and 7th floors, Building 6, No. 99 Jiangwancheng Road,
            Yangpu District, Shanghai, China
          </p>
        </div>
        <div class="text"><h3>Contact Address:</h3></div>
        <div class="text">
          <p>
            6th Floor, Building 6, No. 99 Jiangwancheng Road, Yangpu District,
            Shanghai, China
          </p>
        </div>
        <div class="text"><p>(Zip code: 200438)</p></div>
        <div class="text"><p>Phone: 86-021-28915222</p></div>
        <div class="text"><h3>Registration Authority: &nbsp;</h3></div>
        <div class="text">
          <p>Shanghai Municipal Administration for Industry and Commerce</p>
        </div>
        <div class="text"><h3>VAT ID No.:&nbsp;</h3></div>
        <div class="text"><p>310000400521848</p></div>
        <div class="text"><h3>E-mail Address:</h3></div>
        <div class="text">
          <p>Email address: alicloud.support@henkel.com</p>
        </div>
      </div>
    </div>
    <div v-if="language == 'cn'" class="extendedRichtext">
      <h1>版权声明</h1>
      <div>
        <div class="text">
          <h3>服务提供商:</h3>
        </div>
        <div class="text">
          <p>汉高（中国）投资有限公司，以下简称“汉高公司”或“我公司”）</p>
        </div>
        <div class="text">
          <h3>注册地址:</h3>
        </div>
        <div class="text">
          <p>中国上海市杨浦区江湾城路99号6幢5、6、7层</p>
        </div>
        <div class="text">
          <h3>联络地址：</h3>
        </div>
        <div class="text">
          <p>中国上海市杨浦区江湾城路99号6幢6层</p>
        </div>
        <div class="text">
          <p>（邮编：200438）</p>
        </div>
        <div class="text">
          <p>电话: 86-021-28915222</p>
        </div>
        <div class="text">
          <h3>注册机关:</h3>
        </div>
        <div class="text">
          <p>上海市工商行政管理局</p>
        </div>
        <div class="text">
          <h3>VAT ID No.:</h3>
        </div>
        <div class="text">
          <p>310000400521848</p>
        </div>
        <div class="text">
          <h3>E-mail 地址:</h3>
        </div>
        <div class="text">
          <p>邮箱地址： alicloud.support@henkel.com</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { uiHelper } from "@/core/utils";

export default {
  name: "Imprint",
  data: () => ({}),
  computed: {
    language() {
      return uiHelper.getLocalStorage("language");
    },
  },
};
</script>
<style lang="scss">
.all {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 60px;
  font-size: 10px;
  color: #000;
  font-family: Segoe UI, Helvetica, sans-serif;
  position: relative;
  min-height: 100%;
  .standard-content .text > p:not(.h1-like-headline) {
    margin: 0 0 1.5em;
    max-width: 829px;
  }

  .extendedRichtext {
    width: 70%;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    line-height: 1.428571429;
    font-size: 10px;
    color: #000;
    font-family: Segoe UI, Helvetica, sans-serif;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    h1 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      font-family: inherit;
      line-height: 1.3;
      margin: 0;
      color: #e1000f;
      float: left;
      padding: 0 0 0.75em;
      width: 100%;
      word-wrap: break-word;
      max-width: 100%;
      font-weight: 300;
      font-size: 6rem;
    }
    h2 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-family: inherit;
      line-height: 1.3;
      color: inherit;
      font-weight: 400;
      max-width: 829px;
      font-size: 2.4rem;
      margin-top: 0;
      margin-bottom: 0.65em;
    }
    h3 {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      font-family: inherit;
      line-height: 1.3;
      font-weight: 400;
      color: #e1000f;
      margin-top: 0;
      max-width: 829px;
      font-size: 2.4rem;
      margin-bottom: 0.5em;
    }
    p {
      -webkit-text-size-adjust: 100%;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      line-height: 1.428571429;
      color: #000;
      font-family: Segoe UI, Helvetica, sans-serif;
      box-sizing: border-box;
      padding: 0;
      font-size: 1.6rem;
      margin: 0 0 1.5em !important;
    }
    .fixed-footer {
      position: absolute;
      bottom: 0px;
      right: 0px;
      width: 100%;
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
